<template>
  <div class="fangchan">
    <div class="cardLunbo" v-show="hasCard">
      <div class="showPage">{{ current + 1 }}/{{ cardNum }}</div>
      <van-swipe @change="onChange" :show-indicators="false">
        <van-swipe-item v-for="item in infoList" :key="item.id">
          <div class="cardPic">
            <div class="zhenjian">
              <div class="leftIcon">
                <img src="../assets/images/fangchanIcon.png" alt="" />
              </div>
              <div class="word">
                <div class="zhenjianName">不动产</div>
                <div class="pingzhen">权利标识码：{{ item.qlbsm }}</div>
              </div>
            </div>
            goview(item.pdf)
            <div class="dibu" v-show="hasCard">
              <div class="left" @click="goview(item.pdf)">
                <!-- <img src="../assets/images/dianziIcon.png" alt="" /> -->
                <div class="word">查看电子证照</div>
              </div>
              <!-- <div class="right" @click="handleKookCodeClick">
                <div class="word">查看二维码</div>
                <img
                  style="
                    height: 14px;
                    width: 14px;
                    margin-left: 5px;
                    vertical-align: middle;
                  "
                  src="../assets/images/code-icon.png"
                  alt=""
                />
              </div> -->
            </div>
          </div></van-swipe-item
        >
      </van-swipe>
    </div>
    <div class="cardPic" v-show="!hasCard">
      <div class="zhenjian">
        <div class="leftIcon">
          <img src="../assets/images/fangchanIcon.png" alt="" />
        </div>
        <div class="word">
          <div class="zhenjianName">不动产</div>
          <div class="pingzhen">电子凭证</div>
        </div>
      </div>
      <div class="dibu" v-show="noData">
        <div class="word">暂无数据</div>
      </div>
    </div>
    <div class="info" v-show="hasCard">
      <div class="title">证件信息</div>
      <div class="infoList">
        <div class="everyInfo">
          <div class="left">序号</div>
          <div class="right">{{ infoObj.xh | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">房屋坐落</div>
          <div class="right">{{ infoObj.fwzl | filterValue }}</div>
        </div>

        <div class="everyInfo">
          <div class="left">房屋类型</div>
          <div class="right">{{ infoObj.bdclx | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">权利标识码</div>
          <div class="right">{{ infoObj.qlbsm | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">登记时间</div>
          <div class="right">{{ infoObj.djsj | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">登记类型</div>
          <div class="right">{{ infoObj.djlx | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">房屋用途</div>
          <div class="right">{{ infoObj.fwyt | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">权利类型</div>
          <div class="right">{{ infoObj.qllx | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">权利性质</div>
          <div class="right">{{ infoObj.qlxz | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">权属状态</div>
          <div class="right">{{ infoObj.qszt | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">限制状态</div>
          <div class="right">{{ infoObj.xzzt | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">转移注销时间</div>
          <div class="right">{{ infoObj.zyzxsj | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">不动产单元号</div>
          <div class="right">{{ infoObj.bdcdyh | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">房屋建筑面积</div>
          <div class="right">{{ infoObj.jzmj | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">宗地面积/房屋面积</div>
          <div class="right">{{ infoObj.mj | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">查询区域</div>
          <div class="right">{{ infoObj.cxqy | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">备注</div>
          <div class="right">{{ infoObj.bz | filterValue }}</div>
        </div>
        <div class="everyInfo">
          <div class="left">土地使用期限</div>
          <div class="right">{{ infoObj.tdsyqx | filterValue }}</div>
        </div>
      </div>
    </div>
    <van-popup v-model="codeShow" class="my-popup">
      <vue-qr
        :size="191"
        :margin="0"
        :auto-color="true"
        :dot-scale="1"
        :text="appSrc"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { doRem } from "../utils/setrem";
import VueQr from "vue-qr";

import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";

Vue.use(Toast);

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    this.chakan();
  },
  data() {
    return {
      current: 0,
      hasCard: false,
      infoList: [],
      infoObj: Object,
      cardNum: "",
      appSrc: "",
      codeShow: false,
      noData: false,
    };
  },
  components: { VueQr },

  filters: {
    filterValue: function (value) {
      if (value == "" || typeof value == "undefined") {
        return (value = "无");
      } else {
        return value;
      }
    },
  },
  methods: {
    handleKookCodeClick() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({ cardType: 11 });
      this.$axios
        .post("/identity/user/otherCert/getQRcode", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            this.codeShow = true;
            this.appSrc = res.data.data;
          }
        })
        .catch((err) => {
          Toast.clear();
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    goview(src) {
      this.$router.push({
        name: "ZhenjianView",
        params: {
          src,
        },
      });
    },
    onChange(index) {
      this.current = index;
      this.infoObj = {};
      this.infoObj = this.infoList[index];
    },
    chakan() {
      Toast.loading({
        message: "信息加载中...",
        forbidClick: true,
      });
      this.infoList = [];

      let params = qs.stringify({
        cardType: 11,
      });
      this.$axios
        .post("identity/user/elecCertificate/getCertificateInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            this.noData = true;
            Dialog.alert({
              message: "未查询到相关证件信息",
            }).then(() => {});
            return;
          }
          if (res.data.result == 1) {
            Toast.clear();

            this.hasCard = true;
            res.data.data.forEach((item) => {
              item.qlbsm = item.qlbsm.replace(
                /^(\d{3})\d{4}(\d{4})$/,
                "$1****$2"
              );
              this.infoList.push(item);
            });
            console.log(this.infoList);
            this.cardNum = this.infoList.length;
            this.infoObj = this.infoList[this.current];
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.fangchan {
  background-color: #eef4f6;
  padding: 1.5rem 2rem 6.25rem 2rem;
  min-height: 100vh;
}
.cardLunbo {
  position: relative;
  .showPage {
    position: absolute;
    width: 5.625rem;
    height: 2.75rem;
    background: rgba(0, 0, 0, 0.85);
    color: #ffffff;
    top: 1.875rem;
    right: 1.625rem;
    z-index: 100;
    text-align: center;
    line-height: 2.75rem;
    border-radius: 1.375rem;
  }
}
.cardPic {
  position: relative;
  background-image: url("../assets/images/fangchan.png");
  height: 25rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 4.25rem;
  padding-left: 3.375rem;
  .zhenjian {
    display: flex;
    align-items: center;

    img {
      width: 5.5rem;
    }
    .word {
      margin-left: 1.625rem;
      line-height: 3rem;
      .zhenjianName {
        color: #ffffff;
        font-size: 2rem;
      }
      .pingzhen {
        color: rgba(255, 255, 255, 0.8);
        font-size: 1.625rem;
      }
    }
  }
  .dibu {
    width: 100%;
    background-image: url("../assets/images/dianziBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5.5rem;
    .word {
      margin-left: 1.25rem;
      font-size: 1.875rem;
      color: #ffffff;
    }
    img {
      width: 3.25rem;
      height: 2.375rem;
    }
  }
}
.dibu {
  width: 100%;
  background-image: url("../assets/images/dianziBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5.5rem;
  // .left {
  //   position: relative;
  // }
  // .left::after {
  //   position: absolute;
  //   right: 0;
  //   top: 50%;
  //   margin-top: -7px;
  //   content: "";
  //   height: 14px;
  //   width: 1px;
  //   background-color: #fff;
  // }
  .left,
  .right {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
  div {
    .word {
      margin-left: 1.25rem;
      font-size: 1.875rem;
      color: #ffffff;
    }
    img {
      width: 3.25rem;
      height: 2.375rem;
    }
  }
}
.my-popup {
  padding: 10px;
}
.info {
  background-color: #fff;
  margin-top: -1rem;
  padding: 2.5rem 1.875rem 3rem 2.25rem;
  border-radius: 1rem;
  .title {
    color: #19212a;
    font-size: 2.125rem;
    line-height: 3.125rem;
    font-weight: normal;
  }
  .infoList {
    .everyInfo {
      margin-top: 2.25rem;
      display: flex;
      justify-content: space-between;
      .left {
        color: #555555;
        font-size: 1.875rem;
        line-height: 2.75rem;
      }
      .right {
        color: #19212a;
        font-size: 1.875rem;
        line-height: 2.75rem;
        width: 19.5rem;
        text-align: right;
      }
    }
  }
}
</style>